/**
 * -------------------------------------------------
 * zwraca szerokość paska przewijania
 * @returns {number}
 */
export function getScrollWidth() {
    let $divTest = null;
    if ($(document).height() > $(window).height()) {
        $divTest = $('<div style="overflow-y: auto; opacity:0; height: 50px; position: absolute; bottom:0;"><div style="height: 100px">koty są fajne i psy też</div></div>');
    } else {
        $divTest = $('<div style="overflow-y: auto; opacity:0; height: 100px; position: absolute; bottom:0;"><div style="height: 50px">koty są fajne i psy też</div></div>');
    }

    $(document.body).append($divTest);
    const scrollWidth = $divTest[0].offsetWidth - $divTest[0].clientWidth;
    $divTest.remove();
    return scrollWidth;
}
